export enum E_GravedadPotencial {
    Baja = 1,
    Media = 2,
    Alta = 3
}